import { Action } from 'redux';

import { IContentInfo } from '~src/spacesPlatform/models/IContentInfo';

import { RunExtractRefreshNow } from '../../../bootstrap/redux/actions/AppActionTypes';

export interface RunExtractRefreshNowAction extends Action {
    tasks: IContentInfo[];
}

export function runExtractRefreshNow(tasks: IContentInfo[]): RunExtractRefreshNowAction {
  return {
    type: RunExtractRefreshNow,
    tasks
  };
}
